export const treezGreen = {
    1: "#FCFFF5",
    2: "#F3FAE6",
    3: "#E8F7CD",
    4: "#DBF5B3",
    5: "#A9E079",
    6: "#8CCC52",
    7: "#6BAA32",
    8: "#3E7A18",
    9: "#295C07",
    10: "#1A4007",
};
export const treezGrey = {
    1: "#F7F7F7",
    2: "#F5F5F5",
    3: "#F0F0F0",
    4: "#E6E6E6",
    5: "#BFBFBF",
    6: "#8C8C8C",
    7: "#737373",
    8: "#595959",
    9: "#404040",
    10: "#262626",
};
export const treezSecondaryColors = {
    brown: "#E2CCC0",
    brownDark: "#C69278",
    orange: "#FCC8A2",
    orangeDark: "#FBA466",
    peach: "#F1D9D9",
    peachDark: "#FF9696",
    blue: "#CFDEED",
    blueDark: "#95C1EE",
    purple: "#E0C6EC",
    purpleDark: "#C992E3",
    yellow: "#FBF1CF",
    yellowDark: "#FDE28B",
};
export const treezSystemColors = {
    error: {
        light: "#FDE3E3",
        main: "#DA5050",
        dark: "#BD4141",
    },
    info: {
        light: "#E1EEFA",
        main: "#437DCF",
        dark: "#3774AC",
    },
    success: {
        light: "#E5F9EC",
        main: "#309F56",
        dark: "#2E834B",
    },
    warning: {
        light: "#FFF3E1",
        main: "#E26815",
        dark: "#B45210",
    },
};
export const treezTextColors = {
    disabled: "#949494",
    tertiary: "#7A7A7A",
    secondary: "#595959",
    // note: primaryBlackText hex value is same as #000000 with a 89% opacity.
    primary: "#0F1709",
    primaryWhite: "#FAFAFA",
};
export const treezBlackAndWhiteColors = {
    primaryWhite: "#FFFFFF",
    primaryBlack: "#1A1A1A",
};
